const STORAGE_KEY = 'authUser';

const fetchPersistedUser = () => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return null;
  }

  try {
    const serialized = window.localStorage.getItem(STORAGE_KEY);
    if (!serialized) {
      return null;
    }
    const parsed = JSON.parse(serialized);
    if (!parsed) {
      return null;
    }

    if (parsed.username) {
      return parsed;
    }

    if (parsed.email) {
      return {
        username: parsed.email,
        role: parsed.role || 'admin',
        displayName: parsed.displayName || 'Administrator'
      };
    }

    return null;
  } catch (err) {
    window.localStorage.removeItem(STORAGE_KEY);
    return null;
  }
};

const persistedUser = fetchPersistedUser();

const initialState = {
  isAuthenticated: Boolean(persistedUser),
  user: persistedUser,
  error: null,
  errorField: null,
  isLoading: false
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'LOGIN_REQUEST': {
      return {
        ...state,
        isLoading: true,
        error: null,
        errorField: null
      };
    }
    case 'LOGIN_SUCCESS': {
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
        error: null,
        errorField: null,
        isLoading: false
      };
    }
    case 'LOGIN_FAILURE': {
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        error: action.error,
        errorField: action.field,
        isLoading: false
      };
    }
    case 'LOGOUT': {
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        error: null,
        errorField: null,
        isLoading: false
      };
    }
    default:
      return state;
  }
};

export default authReducer;
